module.exports = __webpack_public_path__ + "static/media/result.9e80ebee.svg";